<template>
  <b-modal
    id="daily-status-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer un état quotidien"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
    :hide-footer="!canBeDeleted"
  >
    <div v-if="selected !== null">
      <div v-if="canBeDeleted">
        Supprimer l'état quotidien ?
      </div>
      <div v-else>
        L'état quotidien ne peut pas être supprimé.
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'DailyStatusDeleteModal',

  props: {
    selected: Object
  },

  computed: {
    canBeDeleted() {
      if (this.selected === null) {
        return false
      }
      return true
    }
  },

  emits: ['didDeleteDailyStatus'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {

      api
        .delete(`/dailyStatus/${this.selected.id}`)
        .then(response => {
          this.$emit('didDelete')
          this.hideModal()
          this.successToast("État quotidien supprimé")
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('daily-status-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/DailyStatusDeleteModal.vue